module.exports = global["$"] = require("-!/home/cocktaildb/releases/20200923120345/node_modules/babel-loader/lib/index.js??ref--13-0!./jquery.js");